import { createRoot } from "react-dom/client";
import App from "./App";
import RecordingsAdmin from "./RecordingsAdmin";

createRoot(document.getElementById("root")!).render(
  window.location.pathname.replace(/\/+$/, "") === "/recordings" ? (
    <RecordingsAdmin />
  ) : (
    <App />
  ),
);
